import { useContext } from 'react';
import { SidebarContext } from 'src/providers/sidebar/context';

export const useSidebar = () => useContext(SidebarContext);
